import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Filters from "../../Misc/Filters";
import allDocuments from "../Workdoc/typedoc";

export default class TrackerFilters extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      peding: false,
      filters: false,
    };
  }

  makeFilters = async () => {
    this.setState({ peding: true });

    let ships = await this.context.api.qac("/ship/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    let shipVariants = [];
    ships.forEach((item) =>
      shipVariants.push([
        item.name,
        [{ field: "ship", compare: "EQL", value: item.id }],
      ])
    );

    let harbor = await this.context.api.qac("/harbor/list");
    let harborArrivalVariants = [];
    let harborDepartureVariants = [];
    harbor.forEach((item) => {
      harborArrivalVariants.push([
        item.name,
        [{ field: "arrival", compare: "EQL", value: item.id }],
      ]);

      harborDepartureVariants.push([
        item.name,
        [{ field: "departure", compare: "EQL", value: item.id }],
      ]);
    });

    this.setState({
      peding: false,
      filters: {
        documents: this.props.types || [],
        active: [],
        native: [
          {
            id: "validfromdate",
            title: "Дата начала",
            kind: "range",
            active: false,
            value: [],
          },
          {
            id: "validtodate",
            title: "Дата окончания",
            kind: "range",
            active: false,
            value: [],
          },
          {
            id: "ship",
            title: "Судно",
            kind: "dropdown",
            multiple: true,
            active: false,
            activeVariants: [],
            variants: shipVariants,
          },
          {
            id: "departure",
            title: "Порт отправления",
            kind: "dropdown",
            multiple: true,
            active: false,
            activeVariants: [],
            variants: harborDepartureVariants,
          },
          {
            id: "arrival",
            title: "Порт прибытия",
            kind: "dropdown",
            multiple: true,
            active: false,
            activeVariants: [],
            variants: harborArrivalVariants,
          },
        ],
      },
    });
  };

  onDocumentToggle = (idx) => {
    this.setState(
      (state) => {
        let filters = state.filters || {};
        let documents = filters.documents || [];
        if (documents[idx]) {
          documents[idx].active = !documents[idx].active;
        }
        filters.documents = documents;
        return { filters };
      },
      () => this.applyFilters()
    );
  };

  handleFilters = (changedFilters) => {
    this.setState(
      (state) => {
        let filters = state.filters;
        filters.active = changedFilters;
        return { filters };
      },
      () => this.applyFilters()
    );
  };

  applyFilters = () => {
    let result = [...this.state.filters.active];
    let activeDocuments = [];
    this.state.filters.documents.forEach((item) => {
      if (item.active) {
        activeDocuments.push(item.code);
      }
    });
    if (activeDocuments.length > 0) {
      result.push({
        lstr: "(",
        field: "typecode",
        valarr: activeDocuments,
        rstr: ")",
      });
    }
    this.props.handleFilters(result);
  };

  componentDidMount() {
    this.makeFilters();
  }

  render() {
    const { filters, peding } = this.state;
    return (
      <>
        <Blocker spinnerFixed on={peding}>
          {filters && (
            <div className="wide-filters">
              <b>По типу:</b>
              {filters.documents.map((item, idx) => {
                return (
                  <div className="mt-4" key={idx}>
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="multiple"
                        onChange={() => this.onDocumentToggle(idx)}
                        checked={item.active}
                      />
                      <span className="mr-3"></span>

                      {item.name}
                    </label>
                  </div>
                );
              })}
              <div className="mt-10">
                <b>По параметрам:</b>
              </div>
              <Filters
                key={JSON.stringify(filters.native)}
                filters={filters.native}
                changeFn={this.handleFilters}
              />
            </div>
          )}
        </Blocker>
      </>
    );
  }
}
